import { UserRole } from '@shared/services';

export const roleMapping: { [key in UserRole]: string } = {
  [UserRole.SUPER_ADMIN]: 'Super Admin',
  [UserRole.INSPECTOR]: 'Inspector',
  [UserRole.PROVEN_INSPECTOR]: 'Proven inspector',
  // Training / audit roles
  [UserRole.TRAINEE_INSPECTOR]: 'Trainee inspector',
  [UserRole.AUDITOR]: 'Auditor',
  // Basic roles
  [UserRole.COMPANY_ROOT]: 'Company root',
  [UserRole.COMPANY_ADMIN]: 'Company admin',
  [UserRole.COMPANY_LOCATION_MANAGER]: 'Location manager',
  [UserRole.COMPANY_STANDARD_USER]: 'Standard user',
  [UserRole.COMPANY_ADVANCED_USER]: 'Advanced user',
  [UserRole.COMPANY_CUSTOMS_USER]: 'Custom user',
  // Leasing roles
  [UserRole.COMPANY_READ_ONLY_USER]: 'Read-only user',
  [UserRole.COMPANY_INSPECTOR_COORDINATOR]: 'Inspector coordinator',
  // Flooring roles
  [UserRole.FLOORING_DEALERSHIP_MANAGER]: 'Dealership manager',
  [UserRole.FLOORING_FINANCE_MANAGER]: 'Finance manager',
  [UserRole.FLOORING_MANAGER]: 'Manager',
  [UserRole.FLOORING_AUDITOR]: 'Auditor',
};

export const normalizeUserRole = (userRole: UserRole): string => {
  return roleMapping[userRole] || 'Unknown';
};
